import { render, staticRenderFns } from "./alerts_dashboard.vue?vue&type=template&id=1d6df5e0&scoped=true&"
import script from "./alerts_dashboard.vue?vue&type=script&lang=js&"
export * from "./alerts_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6df5e0",
  null
  
)

export default component.exports